import AmazonIcon from "@redotech/redo-icons/carriers/amazon.svg";
import DHLIcon from "@redotech/redo-icons/carriers/dhl.svg";
import FedExIcon from "@redotech/redo-icons/carriers/fedex.svg";
import NoCarrierIcon from "@redotech/redo-icons/carriers/no-carrier.svg";
import UPSIcon from "@redotech/redo-icons/carriers/ups.svg";
import USPSIcon from "@redotech/redo-icons/carriers/usps.svg";

export function getCarrierIcon(carrier: string | null | undefined) {
  if (!carrier) {
    return NoCarrierIcon;
  }
  const c = carrier.toLowerCase();
  if (c.includes("ups")) {
    return UPSIcon;
  }
  if (c.includes("fedex")) {
    return FedExIcon;
  }
  if (c.includes("usps")) {
    return USPSIcon;
  }
  if (c.includes("dhl")) {
    return DHLIcon;
  }
  if (c.includes("amazon")) {
    return AmazonIcon;
  }
  return NoCarrierIcon;
}
